import { map, mergeMap } from 'rxjs/operators'
import { ajax } from 'rxjs/ajax';
import { Action } from 'redux';
// import {forkJoin} from 'rxjs';

import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import indexReducer  from '../reducers/indexReducer';
import {IIndexStateType} from '../typings/shared';
// import {merge} from "dot-prop-immutable";


export enum IndexActionTypes {
    FETCH_CONTENT = 'FETCH_CONTENT',
    // UPDATE_CONTENT_LINK = 'UPDATE_CONTENT_LINK'
}

export interface IFetchContentAction extends Action<IndexActionTypes.FETCH_CONTENT> {payload: {id}}
// export interface IUpdateContentAction extends Action<IndexActionTypes.UPDATE_CONTENT_LINK> { }

const fetchContentUrl = (id: string) =>{
    return `https://devnet-testing.cisco.com/v1/terms/${id ||'terms-and-conditions'}/commits/latest`
};

export default {
    actions: {
        fetchContent: (id: string): IFetchContentAction => ({ type: IndexActionTypes.FETCH_CONTENT,  payload: { id } }),
    },
    Epics: {
        fetchContentEpic: (action$: ActionsObservable<IFetchContentAction>, state$: StateObservable<IIndexStateType>) => action$.pipe(
            ofType(IndexActionTypes.FETCH_CONTENT),
            mergeMap(action => ajax.getJSON(fetchContentUrl(action.payload.id)).pipe(
                map((response: any) => {
                    console.log(action);
                    return response.files[0].link
                    // return indexReducer.actions.getGeneralUpdateAction("", response)
                }),
                mergeMap(url => ajax({
                    url: url,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'text/plain; charset=utf-8',
                    },
                    responseType:'text'
                }).pipe(
                    map((res: any) => {
                        // console.log((res.response));
                        return indexReducer.actions.getGeneralUpdateAction("content", res.response)
                    })
                )),
            )),
        ),
    }
};
